import InvoiceConfiguration from './invoice-configuration';
import {
  BaseEntity,
  JsonApiProperty,
  JsonApiRelationship,
  JsonApiResource,
} from '../../jsonapi-provider';
import { LocalDate } from '../../utils/local-date';
import Customer from '../customer';
import type SiteInvoice from '../site-invoice';

@JsonApiResource({
  type: 'invoice',
})
export default class Invoice extends BaseEntity {
  @JsonApiProperty({ resolver: (val: any) => new LocalDate(val) })
  public startDate: LocalDate;

  @JsonApiProperty({ resolver: (val: any) => new LocalDate(val) })
  public endDate: LocalDate;

  @JsonApiRelationship('site-invoice')
  public siteInvoices: SiteInvoice[];

  @JsonApiRelationship('customer')
  public customer: Customer;

  @JsonApiRelationship('invoice-configuration')
  public invoiceConfiguration: InvoiceConfiguration;

  @JsonApiProperty({ resolver: Number }) public totalPrice: number = 0.0;

  @JsonApiProperty({ resolver: Number }) public totalPriceWithTaxes: number = 0.0;

  constructor(
    id?: BaseEntity['id'],
    startDate: LocalDate = new LocalDate().startOf('month'),
    endDate: LocalDate = new LocalDate().endOf('month'),
    public invoiceNumber: string = '',
    public paymentStatus: 'PAID' | 'PENDING' | 'UNPAID' = 'UNPAID',
    totalPrice: number = 0.0,
    totalPriceWithTaxes: number = 0.0,
    siteInvoices: Invoice['siteInvoices'] = [],
    customer: Invoice['customer'] = new Customer(),
    invoiceConfiguration: Invoice['invoiceConfiguration'] = new InvoiceConfiguration()
  ) {
    super();
    this.id = id;
    this.startDate = startDate;
    this.endDate = endDate;
    this.siteInvoices = siteInvoices;
    this.customer = customer;
    this.totalPrice = totalPrice;
    this.totalPriceWithTaxes = totalPriceWithTaxes;
    this.invoiceConfiguration = invoiceConfiguration;
  }
}
